import { takeLatest, take, put } from 'redux-saga/effects';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import { consts as commentsList } from './commentsList';
import { consts as postDetails } from './postDetails';
import { consts as postsList } from './postsList';

export const consts = createReqConsts('communities', 'deleteComment');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'posts',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['postId'],
    },
    'comments',
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

export default createReqReducer(consts);

function* deletedCommentWorker(action) {
  const { postId } = action.payload;
  yield take(consts.SUCCEED);

  yield put({
    type: commentsList.DELETE_COMMENT,
    payload: action.payload,
  });

  yield put({
    type: postDetails.DELETE_COMMENT,
  });

  yield put({
    type: postsList.POST_COMMENTS_CHANGED,
    payload: {
      postId,
      change: -1,
    },
  });
}

export function* deletedCommentSaga() {
  yield takeLatest(consts.SEND, deletedCommentWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/deleteComment.js